const permissionGroups = {
    ADMIN: 'admin',
    MANAGER: 'manager',
    POWER: 'power',
    VIEW_ONLY: 'view-only',
};

export default permissionGroups;
